import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
// ui
// 語系
// style
// components
import TemplateHome from "../components/TemplateHome";
import TopSec from "./components/topSec/TopSec";
import OutServiceSec from "./components/outServiceSec/OutServiceSec";
import FeatureIntroSec from "./components/featureIntroSec/FeatureIntroSec";
import BottomSec from "./components/bottomSec/BottomSec";
import HomeBg from "./components/HomeBg";
import useGotoWorkingArea from "../components/hook/useGotoWorkingArea";
// utils

//
const HomePage = () => {
  // props
  // store
  // local state

  // hooks: 若使用者已登入,則導向其他頁面
  const isLoggedIn = useGotoWorkingArea();

  return (
    <TemplateHome>
      <HomeBg>
        {/* top */}
        <TopSec />
        {/* our service */}
        <OutServiceSec />
        {/* feature introduction */}
        <FeatureIntroSec />
        {/* bottom (include foot ) */}
        <BottomSec />
      </HomeBg>
    </TemplateHome>
  );
};

HomePage.propTypes = {};

HomePage.defaultProps = {};

export default HomePage;
